import type { RelatedDocumentsPanelData } from './useRelatedDocumentsPanelData.types';

import { getDocumentDetailsExpandedRelatedDocsType } from 'shared/features/rightPanel/rightPanel.selectors';
import { DEFAULT_RELATION_TYPES_EXPANDED } from '../RelatedDocumentsPanel.constants';

import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useRelatedDocumentsPanelData = (): RelatedDocumentsPanelData => {
  const [expanded, setExpanded] = useState<RelatedDocumentsPanelData['localState']['expanded']>(
    DEFAULT_RELATION_TYPES_EXPANDED
  );
  const [addModal, setAddModal] = useState<RelatedDocumentsPanelData['localState']['addModal']>({
    isOpen: false,
    relationType: undefined
  });
  const [deleteModal, setDeleteModal] = useState<
    RelatedDocumentsPanelData['localState']['deleteModal']
  >({ isOpen: false, relationType: undefined });

  const localState = {
    expanded,
    addModal,
    deleteModal
  };

  const localActions = useMemo(
    () => ({
      setExpanded,
      setAddModal,
      setDeleteModal
    }),
    [setExpanded, setAddModal, setDeleteModal]
  );

  const reduxState = useSelector(state => ({
    expandedRelatedDocsType: getDocumentDetailsExpandedRelatedDocsType(state as never)
  }));

  return {
    localState,
    localActions,
    reduxState
  };
};
